import { Component, ElementRef, OnInit, ViewChild, Input } from '@angular/core'
import { Router } from '@angular/router'
import { FormBuilder, Validators } from '@angular/forms'
import { ICON_TYPE, LaunchDialogService } from '@spartacus/storefront'
import { GlobalMessageType, GlobalMessageService } from '@spartacus/core'
import { SavedCartService } from '../saved-cart.service'
import { MultiCartFacade } from '@spartacus/cart/base/root'
import { CommonService } from '../../../../shared/services/common.service'
import { DialogResponse, VS_LAUNCH_CALLER } from '../../../config/dialog.config'
import { PRE_URL } from '../../../../shared/constants'

@Component({
  standalone: false,
  selector: 'app-create-saved-cart-dialog',
  templateUrl: './create-saved-cart-dialog.component.html',
  styleUrls: ['./create-saved-cart-dialog.component.scss'],
})
export class CreateSavedCartDialogComponent implements OnInit {
  iconTypes = ICON_TYPE
  modalIsOpen = false
  cartName = ''
  cartDescription = ''
  nameErrorMessage = ''
  duplicateErrorMessage = ''
  showCartError = false
  showDuplicateCartErr = false
  showLoader = false

  currentUser

  currentCart: any = null

  createSavedCartForm = this.fb.group({
    description: [''],
    cartName: ['', Validators.required],
  })
  dataSource = []

  constructor(
    private launchDialogService: LaunchDialogService,
    private fb: FormBuilder,
    private commonService: CommonService,
    private router: Router,
    private multiCartFacade: MultiCartFacade,
    private globalMessageService: GlobalMessageService,
    private savedCartService: SavedCartService
  ) {}

  ngOnInit() {
    this.launchDialogService.data$.subscribe((data) => {
      this.currentCart = data.currentCart
    })
    this.commonService.getUserData().subscribe(
      (user) => {
        this.currentUser = user
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          10000
        )
        window.scrollTo(0, 0)
      }
    )
    this.loadCartData()
  }

  dismissModal(reason?: any): void {
    const dialogResponse: DialogResponse = {
      type: VS_LAUNCH_CALLER.CREATE_SAVED_CART,
      reason: reason,
    }
    this.launchDialogService.closeDialog(dialogResponse)
  }

  onSubmit() {
    this.nameErrorMessage = ''
    if (!this.cartName.trim().length) {
      this.showDuplicateCartErr = false
      this.showCartError = true
      this.nameErrorMessage = 'Please enter cart name'
      return
    }

    // if (this.dataSource.length < 8) {
    if (this.createSavedCartForm.valid) {
      this.showLoader = true
      this.commonService
        .patchData(
          `${PRE_URL}/users/${this.currentUser.uid}/carts/${this.currentCart.code}/save`,
          {},
          {
            params: {
              saveCartName: this.cartName,
              saveCartDescription: this.cartDescription,
              isRfqCart: false,
            },
            responseType: 'text',
          }
        )
        .subscribe(
          (res: any) => {
            this.showLoader = false
            if (Number(res)) {
              this.multiCartFacade.loadCart({
                userId: 'current',
                cartId: `${res}`,
                extraData: {
                  active: true,
                },
              })
              this.globalMessageService.add(
                {
                  key: 'savedCart.cartSaveSuccess',
                  params: { cartName: this.cartName },
                },
                GlobalMessageType.MSG_TYPE_CONFIRMATION,
                9000
              )
              window.scrollTo(0, 0)
              this.dismissModal('Dismissing after successful save')
            } else {
              // Error message here for cart name available
              this.nameErrorMessage = res
              this.showCartError = true
              // this.duplicateErrorMessage = 'Cart name already exists'
            }
          },
          (err) => {
            let errorMsg = ''
            this.showLoader = false
            if (err !== undefined && err['error'] !== undefined) {
              if (err.error?.errors[0]?.message == '102') {
                this.showCartError = false
                this.showDuplicateCartErr = true
                this.duplicateErrorMessage = 'Cart name already exists'
              } else if (err.error?.errors[0]?.message == '101') {
                this.savedCartService.maxSavedCartErrorNotification.next(true)
                setTimeout(() => {
                  this.savedCartService.maxSavedCartErrorNotification.next(
                    false
                  )
                }, 9000)

                setTimeout(() => {
                  window.scrollTo(0, 0)
                }, 1500)
                this.dismissModal('Dismissing after successful save')
              } else {
                this.globalMessageService.add(
                  { key: 'savedCart.issueWhileSavingCart' },
                  GlobalMessageType.MSG_TYPE_ERROR,
                  5000
                )
              }
            }
          }
        )
    } else {
      this.createSavedCartForm.markAllAsTouched()
    }
    //  return false;
    // } else {
    //   // this.globalMessageService.add(
    //   //   `You already have reached max. limit of saved carts. Please visit saved carts to remove saved carts if any.`,
    //   //   GlobalMessageType.MSG_TYPE_ERROR,
    //   //   5000
    //   // );

    //   this.savedCartService.maxSavedCartErrorNotification.next(true);
    //   setTimeout(() => {
    //     this.savedCartService.maxSavedCartErrorNotification.next(false);
    //   },9000);

    //   window.scrollTo(0, 0);
    //   this.dismissModal('Dismissing after successful save');
    // }
  }

  loadCartData() {
    if (!this.currentUser.uid) {
      return
    }
    const url = this.commonService.constructUrl([
      'users',
      this.currentUser.uid,
      `carts?savedCartsOnly=true&fields=FULL&pageSize=30&sort=byDateSaved`,
    ])
    this.commonService.getData(url).subscribe(
      (data: any) => {
        this.dataSource = data['carts']
      },
      (err) => {
        this.globalMessageService.add(
          err,
          GlobalMessageType.MSG_TYPE_ERROR,
          10000
        )
        window.scrollTo(0, 0)
        this.dataSource = []
      }
    )
  }
}
